// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"057d12dc","320":"0c09003e","604":"d3a539b5","616":"d1dcdaa9","849":"79da0874","875":"1c1e1609","893":"d15e4448","950":"210422db"}[chunkId] + ".chunk.js";
};